const author = {
  rus: 'Татьяна Аудерская'
};

export default author;